import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Button, Tooltip, message } from 'antd';
import { CreditCardOutlined, EditOutlined, FileAddOutlined } from '@ant-design/icons'
import i18n from "i18next";
import { SkosScheme, AdmsAsset, RdfTriplet } from '../../redux';
import { getValues, subsetByURI } from '../../virtuoso/helper'
import settings from '../../virtuoso/settings';
import SelectProperty from '../../components/widgets/SelectProperty';
import { filterAddedPredicates } from '..//helper';
import { FieldViewProxy, FieldEditProxy } from '../../components/adms/FieldProxies';
import { getSelectedIRI } from '../../components/editor/helper';
import SelectIndividualForm from '../../components/editor/SelectIndividualForm';
import PropertyLabel from '../../components/owl/ProperyLabel';


/** Отображение списка значений для карточки с информацией о каталоге (dcat:Catalog)
 * Формируется таблица, содержащая столбец с названием поля и столбец со значением поля
 * Для отображения поля используются специальные компоненты. Виды компонент описаны в widgets.
 * Получает список 
 */
const serviceFields = [];
const sortedStartPart = ["http://www.w3.org/1999/02/22-rdf-syntax-ns#about", "http://purl.org/dc/terms/language",
"http://www.w3.org/2000/01/rdf-schema#label", "http://purl.org/dc/terms/description"]
const sortedFinishPart = ["http://www.w3.org/2002/07/owl#versionInfo", "http://csi.semanticpro.org/2016/ns#prefix",
"http://www.w3.org/2000/01/rdf-schema#comment"]
const exclude = ["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];


//Фильтрует полученные свойства для отображения. Исключает служебные свойства, свойства с пустыми значениями
//predicates содержит все предикаты, имеющие значения
const filterForShow = (factory, predicates, values) => {
    //console.log("const filterForShow = (factory, predicates, values)", predicates, values);
    //Исключаем служебные элементы. Пока их нет!
    if (!Array.isArray(predicates))
      return [];
    const first = predicates.filter(key => !serviceFields.includes(key)); 
    //Исключаем свойства, которые не должны показываться
    const properties = first.filter(key => !exclude.includes(key));
    //Формируем последовательность свойств для отображения
    //console.log(properties)
    return properties.sort ((a, b) => {
            //console.log("0", a, b);
            //Начало списка свойств
            let indexA = sortedStartPart.indexOf(a);
            let indexB = sortedStartPart.indexOf(b);
            //console.log("1", indexA, indexB);
            if (indexA>-1){
                if (indexB>-1) return indexA-indexB;
                return -1;
            };
            if (indexB>-1) return 1;
            //конец списка свойств
            indexA = sortedFinishPart.indexOf(a);
            indexB = sortedFinishPart.indexOf(b);
            //console.log("2", indexA, indexB);
            if (indexA>-1){
                if (indexB < 0) return 1;
                return indexA-indexB;
            };
            if (indexB>-1) return 1;
            return 0;
        });
}


/**
 * 
 * @param {*} formRef 
 * @param {*} IRI - текущий выбранный элемент (IRI)
 * @param {*} factory - фабрика получения информкции о списка доступных свойств и их аннотации
 * @param {*} existing - массив существующих у объекта свойств (предикат + объекта)
 * @param {*} lang  - текущий язык
 * @param {*} onFinishOperation - callback для добавления
 * @param {*} onCancelOperation - callback для отмены
 * @returns 
 */
const showAddProperty = (formRef=f=>f, IRI, existing, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
  //console.log("syncPercent", syncPercent);
  return <Modal style={{minWidth: "80%"}} open={true} title={i18n.t('views.skos.conceptCard.addProperty')} cancelText={i18n.t('views.skos.common.cancel')} okText={i18n.t('views.skos.common.ok')}
    onCancel={onCancelOperation} onOk={onFinishOperation} destroyOnHidden>
        <SelectProperty formRef={formRef} subjectIri={IRI} existing={existing} 
          factory={factory} lang={lang}/>
    </Modal>
}

/** Показать диалог выбора индивидуала */
const showSelectIndividual = (formRef=f=>f, IRI, predicat, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  //console.log("syncPercent", syncPercent);
  return <Modal style={{minWidth: "80%"}} open={true} title={i18n.t('views.skos.conceptCard.selectItem')} cancelText={i18n.t('views.skos.common.cancel')} okText={i18n.t('views.skos.common.ok')}
    onCancel={onCancelOperation} onOk={onFinishOperation} okButtonProps={{disabled: !getSelectedIRI(selected)}}>
        <SelectIndividualForm formRef={formRef} IRI={IRI} predicat={predicat}
          factory={factory} lang={lang}/>
    </Modal>
}

const { confirm } = Modal;
/** Форимрует выподающий список для операций */
const ButtonGroup = Button.Group;
/** Базовая компонента отображения свойств каталога.
 * Обработка событий при модификации содрежимого происходит в родительской компоненте. 
 * Для этого из родительского компонента передаётся handlers
 */
class ConceptCard extends React.Component {

  state = {
      selected: undefined,       //Свойство (predicat), которое редактируется, удаляется или для него осуществляется перевод
      operation: "view",         //Текущая операция. Может быть view, edit, delete

      adding: false,            //Флаг, для отображения далога добавления нового свойства
      addedPredicates: [],      //Добавленные предикаты

      linkSelectModal: false,
      linkSelectSubject: undefined,
      linkSelectPredicat: undefined,
      linkSelectResolve: undefined,
      linkSelectReject: undefined,
    }

  formRef = React.createRef();

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.values !== this.props.values && this.state.addedPredicates.length > 0) {
      const addedPredicates = filterAddedPredicates(
        this.state.addedPredicates,
        this.props.values
      );

      if (addedPredicates.length !== this.state.addedPredicates.length) {
        this.setState({ addedPredicates });
        return;
      }
    };
  };
    
  /** Обработчик действий над элементом в форме  */
  onAction (e, type, predicat) {
    e.preventDefault();
    //console.log("CatalogData.js onAction", e, type, predicat); console.log(this); 
    //Режим редактирования, удаления или перевода
    if ((type=="edit")||(type=="translate")){
      const { iri, lang, values, onSelected} = this.props;
        const value = getValues(predicat, lang, values);
        this.setState({selected: predicat});
        onSelected(type, iri, predicat, value);
        return;
    }
    if (type=="delete"){
        const { iri, onRemoveProperty } = this.props;
        const value = getValues(predicat, this.props.lang, this.props.values);
        confirm({
            title: i18n.t('views.skos.conceptCard.deleteProperty'),
            content: value,
            okText: i18n.t('views.skos.common.yes'),
            okType: 'danger',
            cancelText: i18n.t('views.skos.common.no'),
            onOk() {
              //console.log('OK', iri, predicat);
              onRemoveProperty(iri, predicat);
            },
            onCancel() {
                //this.setState({selected: predicat, operation: "view"})
            },
          });
        return;
    }
    if (type=="cancel"){
        this.setState({selected: predicat, operation: "view"})
        return;
    }
    if (type=="detail"){
        const {handlers} = this.props;
        if (handlers) 
          handlers(e, predicat, type);
    }
    //Добавление новой ссылки в объектное совойства
    if (type=="link" || type == "unlink"){
      this.setState({objectProperty: predicat, selected: predicat});
    }
    //Добавление новой ссылки c созданием объекта
    if (type=="new"){
      this.setState({selected: predicat});
    }
  }

  onSelectOperation(e, operation) { 
    e.preventDefault();    
    //Добавление нового свойства
    if (operation=="add"){
      this.setState({adding: true});
      return;
    };    
    this.setState({operation});
  }
  submitAddProperty() {
    this.setState({adding: false, operation: "edit"});
    const form  = this.formRef.current;
    form.validateFields()
     .then((values) => {
        const addedPredicates = [ ... this.state.addedPredicates, {object:{state: 'new'}, predicat : {type: 'uri', value: values.predicateIri}}];
        this.setState({selected: values.predicateIri, adding: false, operation: "edit", addedPredicates});
    }).catch((errorInfo) => {
      console.log(errorInfo);
    });
  };

  cancelOperation(){
    this.setState({selected: undefined, adding: false});
  }

  onSelectLink = ({ subject, predicat, factory }) => {
    return new Promise((resolve, reject) => {
        this.setState({ linkSelectModal: true, linkSelectSubject: subject, linkSelectPredicat: predicat,
          linkSelectResolve: resolve, linkSelectReject: reject,
        });
      });
  };

  onSelectLinkOk = () => {
    const { linkSelectResolve } = this.state;

    const selectedIRI = getSelectedIRI(this.props.vselected);

    if (!selectedIRI) {
      if (linkSelectResolve) {
        linkSelectResolve(undefined);
      }

      this.setState({ linkSelectModal: false,linkSelectSubject: undefined, linkSelectPredicat: undefined,
        linkSelectResolve: undefined, linkSelectReject: undefined, });

      return;
    }

    if (linkSelectResolve) { linkSelectResolve(selectedIRI); }

    this.setState({ linkSelectModal: false, linkSelectSubject: undefined, linkSelectPredicat: undefined, 
      linkSelectResolve: undefined, linkSelectReject: undefined });
  };

  onSelectLinkCancel = () => {
    const { linkSelectReject } = this.state;

    if (linkSelectReject) { linkSelectReject(new Error(i18n.t('views.skos.conceptCard.selectionCancelled'))); }

    this.setState({ linkSelectModal: false, linkSelectSubject: undefined, linkSelectPredicat: undefined,
      linkSelectResolve: undefined, linkSelectReject: undefined, });
  };  

  onAppendLink = (subject, predicat, objectIRI) => {
    const { onInsertProperty, onReload, graph } = this.props;
    onInsertProperty(RdfTriplet, subject, predicat, objectIRI)
      .then (result =>{
          //Обновим каталог
          if (onReload)
            onReload(subject, graph).then(result2=> {
              message.success(i18n.t('components.editor.individual.message.ok_new'));
            });
          else{
            message.success(i18n.t('views.skos.conceptCard.reloadToViewChanges'));
          };
      })
      .catch(info => {
        message.error(i18n.t('components.editor.individual.message.e_new', {detail: info}));
      });
  };

  onDeleteLink = (subject, predicat, objectIRI) => {
    const { onDeleteElement, onReload, graph } = this.props;
    onDeleteElement(RdfTriplet, subject, predicat, objectIRI)
      .then (result =>{
        //Обновим каталог
        if (onReload)
          onReload(subject, graph).then(result2=> {});
        else  
          message.success(i18n.t('views.skos.conceptCard.reloadToViewChanges'));
      })
      .catch(info => {
        message.error(i18n.t('components.editor.individual.message.e_unlink', {detail: info}));
      });
  };

  render(){
    //console.log(this); 
    const {predicates, values, lang, factory, vselected, iri, onReload, isSignedIn, inGroup} = this.props;
    const operation = "edit";
    const {addedPredicates, adding} = this.state;
    const properties =  filterForShow(factory, predicates, values)
    const addedProperies = Array.isArray(addedPredicates)? addedPredicates.map(item => item.predicat.value):[];
    const FieldProxy = (operation=="edit")? FieldEditProxy: FieldViewProxy;
    const linkProps = {
      onSelectLink: this.onSelectLink,
      onAppendLink: this.onAppendLink,
      onDeleteLink: this.onDeleteLink,
      //onNewLink: this.onNewLink,
    };
    const labelStyle = operation=="edit" ? { color: '#bfbfbf' } : undefined;
    return (
      <span>
        <Row className="assetCardTable_tr" style={labelStyle}> 
          <Col span={10} className="assetCardTable_td"><div className="csi_field_div">URI</div></Col>
          <Col span={14} className="assetCardTable_td"><div className="csi_value_div">{iri}</div></Col>
        </Row>


        {properties.map((prop, i) => {
          const viewComponent = factory?.ui?.getUIComponent ? factory.ui.getUIComponent(prop) : undefined;
          const editComponent = factory?.ui?.getUIComponent ? factory.ui.getUIComponent(prop, 'edit') : undefined;
          const isSameViewAndEditComponent = Boolean(operation === "edit" && viewComponent && editComponent && viewComponent === editComponent);
          const labelStyle = isSameViewAndEditComponent ? { color: '#bfbfbf' } : undefined;

          return (
            <Row key={i} className="assetCardTable_tr" style={labelStyle}>
              <Col span={10} className="assetCardTable_td">
                <PropertyLabel iri={prop} factory={factory} isEdit={operation == "edit"} />
              </Col>

              <Col span={14} className="assetCardTable_td" style={{ display: "block" }}>
                <FieldProxy
                  factory={factory}
                  lang={lang}
                  subject={iri}
                  predicat={prop}
                  values={values}
                  vselected={vselected}
                  onReload={() => onReload(iri)}
                  {...this.state}
                  action={(e, type, predicat) => this.onAction(e, type, predicat)}
                />
              </Col>
            </Row>
          );
        })}        


        {Array.isArray(addedProperies) && 
          addedProperies.map((prop) => 
            <Row key={prop} className="assetCardTable_tr"> 
              <Col span={10} className="assetCardTable_td">
                <PropertyLabel iri={prop} factory={factory} warning={true} />
              </Col>
              <Col span={14} className="assetCardTable_td" style={{display: "block"}}>
                <FieldProxy 
                  factory={factory} lang={lang} 
                  subject={iri} predicat={prop} values={values} vselected={vselected}
                  onReload={onReload}
                  {...this.state}
                  {...linkProps}                  
                  action={(e, type, predicat)=> this.onAction(e, type, predicat)}/>
              </Col>
            </Row>
        )}

        <Row>          
          <Col align="right" span={24} style={{"flexDirection": "row-reverse"}}>
          {isSignedIn && inGroup.PowerUser && (
            <ButtonGroup>
              {adding && 
                showAddProperty(this.formRef, iri, [...predicates, ...addedPredicates], factory, lang, 
                  ()=>this.submitAddProperty(), ()=>this.cancelOperation())
              }
              { operation != "view" && (
                <>
                  <Tooltip placement="top" title={i18n.t('views.skos.conceptCard.addProperty')}>
                      <Button icon={<FileAddOutlined />} onClick={(e)=> this.onSelectOperation(e, "add")}/>
                  </Tooltip>
                    {/* &nbsp;&nbsp;
                  <Tooltip placement="top" title={"Режим просмотра данных"}>
                    <Button type="primary" icon={<CreditCardOutlined />} onClick={(e)=> this.onSelectOperation(e, "view")} />
                  </Tooltip> */}
                </>
              )}
              {/* {operation !="edit" && (
                <Tooltip placement="top" title={"Режим редактирования"}>
                  <Button icon={<EditOutlined />} onClick={(e)=> this.onSelectOperation(e, "edit")}/>
                </Tooltip>
              )} */}
            </ButtonGroup>
          )}
          </Col>
        </Row>
        {this.state.linkSelectModal && showSelectIndividual(this.formRef, iri, this.state.linkSelectPredicat, factory, lang, this.onSelectLinkOk, this.onSelectLinkCancel, vselected)}
      </span>
    )
  }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vset, scheme} = state;
    const {lang} = props;
    return {
        lang: (lang)?lang: vset.lang,
        ...scheme.details[props.concept],
        isSignedIn: vset.isSignedIn,
        inGroup: vset.inGroup,
        vselected: props.concept,
        iri: props.concept,
        factory: props.factory
    };
}
export default connect(
  mapStateToProps,
  dispatch => ({
    onReload(IRI){
      return dispatch(SkosScheme.loadConcept(IRI));
    },
    onSelected(type, subject, prdicat, object){
      return dispatch(RdfTriplet.SELECTED(type, subject, prdicat, object));
    },
    onRemoveProperty(subject, predicat){
      return dispatch(AdmsAsset.removeProperty(subject, predicat));
    },
  })
)(ConceptCard);
